import { apiJsonHeaders, withApiLocale } from "../utils/apiLocale";

const BASE_URL = "/api/appointments";

export const cancelAppointment = async ({
  appointmentId,
  cancelledBy,
  cancellationReason,
  notifyPatient = false,
}) => {
  const res = await fetch(`${BASE_URL}/${appointmentId}/cancel`, {
    method: "POST",
    headers: apiJsonHeaders(),
    body: JSON.stringify(
      withApiLocale({
        cancelled_by: cancelledBy,
        cancellation_reason: cancellationReason || null,
        notify_patient: notifyPatient,
      })
    ),
  });

  const data = await res.json().catch(() => ({}));
  if (!res.ok) {
    throw new Error(data?.error || "Error al cancelar el turno");
  }
  return data;
};

export const cancelBulkByDates = async ({
  doctorId,
  cancelledBy,
  dates,
  cancellationReason,
  notifyPatients = true,
}) => {
  const res = await fetch(`${BASE_URL}/bulk-cancel`, {
    method: "POST",
    headers: apiJsonHeaders(),
    body: JSON.stringify(
      withApiLocale({
        doctor_id: doctorId,
        cancelled_by: cancelledBy,
        dates,
        cancellation_reason: cancellationReason,
        notify_patients: notifyPatients,
      })
    ),
  });

  const data = await res.json().catch(() => ({}));
  if (!res.ok) {
    throw new Error(data?.error || "Error al cancelar los turnos");
  }
  return data;
};

export const previewCancelFromEmail = async (token) => {
  const res = await fetch(
    `${BASE_URL}/cancel-from-email/preview?token=${encodeURIComponent(token)}`,
    {
      method: "GET",
      headers: apiJsonHeaders(),
    }
  );

  const data = await res.json().catch(() => ({}));
  if (!res.ok) {
    throw new Error(data?.error || "Enlace inválido");
  }
  return data;
};

export const cancelFromEmail = async (token) => {
  const res = await fetch(`${BASE_URL}/cancel-from-email`, {
    method: "POST",
    headers: apiJsonHeaders(),
    body: JSON.stringify(withApiLocale({ token })),
  });

  const data = await res.json().catch(() => ({}));
  if (!res.ok) {
    throw new Error(data?.error || "Error al cancelar el turno");
  }
  return data;
};
